import React, { Component } from 'react'
import './LoadingDotsStyles.scss'

class LoadingDots extends Component {
  render () {
    const { className } = this.props
    return (
      <div className={`loading-duc-dots ${className}`}>
        {[1, 2, 3, 4].map((i) => <div key={i} className='loading-dot' />)}
      </div>
    )
  }
}

export default LoadingDots
